import { createQueryKeys } from "../../shared/utils/create-query-keys";

export const agencyMemberKeys = createQueryKeys("agencyMembers", {
  list: null,
});
